import React, { useEffect, useState} from 'react';
import InfoModal from '../../components/psc/lib/InfoModal'
import SingleSelect from '../../components/psc/lib/SingleSelect'
import Confirm from '../../components/psc/lib/Confirm'
import SaveButton from '../../components/psc/lib/SaveButton'

import dateFormat from 'dateformat'
import $ from 'jquery'

import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'

const Stages = (props) => {
    const reportTitle = props.report_title
    const project = props.project
    const hasSmartTemplate = props.has_smart_template
    const hasStages = props.has_stages
    const canDeleteStage = props.can_delete_stage
    const handleSubmit = props.handleSubmit
    
    const [reportStages, setReportStages] = useState(props.report_stages.map(function (s) { s.timestamp = s.id; return s; }) || [])
    const [docxTimeout, setDocxTimeout] = useState(null)
    const [htmlTimeout, setHtmlTimeout] = useState(null)
    const [spinner, setSpinner] = useState('')
    const [addBaselineSpinner, setAddBaselineSpinner] = useState(false)
    const [reportStageHtml, setReportStageHtml] = useState('')
    const [reservedDocuments, setReservedDocuments] = useState([])
    const [stageName, setStageName] = useState('')
    const [stageCode, setStageCode] = useState('')
    const [stageError, setStageError] = useState([])
    
    const [smartStage, setSmartStage] = useState({})
    const [smartDocument, setSmartDocument] = useState({})

    const [showSmartReportModal, setShowSmartReportModal] = useState(false)
    const onCloseSmartReportModal = () => setShowSmartReportModal(false)

    const [showReportStageHtml, setShowReportStageHtml] = useState(false)
    const onCloseReportStageHtml = () => setShowReportStageHtml(false)

    const [showSmartReportInformationModal, setShowSmartReportInformationModal] = useState(false)
    
    useEffect(() => {
        fetch('/v0/documents?document_status_id=1&project_id=' + props.project.id, { credentials: 'same-origin' }) // status = Reserved
            .then(function(response) {
                return response.json()
            })
            .then(function(json) {
                const reserved_documents = json.results.map(item => {
                    item.label = item.reference + ' ' + item.title + ' [' + item.document_status.name + ']'
                    return item
                })
                reserved_documents.unshift({label: 'Select...', value: 0})
                setReservedDocuments(reserved_documents)
            })
    }, [props.project.id])
    
    const handleSubmitError = (error) => {
        setSpinner('')
        setAddBaselineSpinner(false)
        setStageError(error)
    }

    const handleStageSubmit = (event) => {
        if( event ) {
            event.preventDefault()
        }

        if( spinner || addBaselineSpinner ) {
            return
        }

        let error = []

        if( ! stageCode ) {
            error.push('Baseline ID is required')
        }

        if( ! stageName ) {
            error.push('Description is required')
        }

        setStageError(error)
        if ( error.length > 0 ) {
            return
        }

        // We need to save the Report first, since there might be changes there (or it not being created yet!). Then we can create the stage
        const actionProps = handleSubmit()
        if( actionProps === null ) {
            return null
        }
        setAddBaselineSpinner(true)
        actionProps.navigateOverride = function() {}
        const reportCallback = actionProps.successCallback
        actionProps.successCallback = function(json) {
            reportCallback(json)
            const reportID = json.result.id
            
            fetch('/v0/report_stages', {
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({
                    report_id: reportID,
                    name: stageName,
                    code: stageCode
                })
            }).then(response => {
                if (!response.ok) throw response
                return response.json()
            }).then(json => {
                setAddBaselineSpinner(false)
                setStageName('')
                setStageCode('')
                setStageError([])
                setReportStages(reportStages.concat(json.result))
            })
        }
        return actionProps
    }
    
    const removeStage = (stage) => {
        var url = '/v0/report_stages/'+stage.id;
        fetch(url, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(res => {
            let rs = reportStages.filter(function (rs) {
                if(rs.id === stage.id) { return false }
                return true;
            });
            setReportStages(rs)
        })
        .catch(error => console.log('Error deleting stage:', error));
    }
    
    const renderForm = () => {
        if( props.disabled )
            return null
    
        return (
            <div>
                <div className="form-group">
                    <label className="col-sm-2"></label>
                    <div className="col-sm-8">
                        <h3 className="stages--new-baseline">New Baseline</h3>
                        <p>
                            Save your report content as a new configuration Baseline.
                        </p>
                    </div>
                </div>

                <div className="form-group">
                    <label className="col-sm-2 control-label">Baseline ID</label>
                    <div className="col-sm-8">
                        <input className="form-control" type="text" name="stage_code" maxLength="6" value={stageCode} onChange={(e) => setStageCode(e.target.value.toUpperCase())} />
                    </div>
                </div>

                <div className="form-group">
                    <label className="col-sm-2 control-label">Description</label>
                    <div className="col-sm-8">
                        <input className="form-control" type="text" name="stage_name" value={stageName} onChange={(e) => setStageName(e.target.value)} />
                    </div>
                </div>

                <div className="form-group">
            
                    <div className="col-sm-8 col-sm-offset-2">
                        <SaveButton
                            buttonVariant='primary'
                            visible={true}
                            spinnerActive={addBaselineSpinner}
                            label='Create New Baseline'
                            onClick={handleStageSubmit}
                            onError={handleSubmitError}
                        />
                    </div>
                </div>
            </div>
        )
    }
        
    const renderTableRow = (stage) => {
        const wordSpinner = 'word_' + stage.id
        const smartSpinner = 'smart_' +stage.id
        
        const smart = hasSmartTemplate ?
            (
                <button type="button" className={'btn btn-xs btn-info has-spinner ' + (spinner === smartSpinner ? 'active' : '')}
                        onClick={() => { setSmartStage(stage); setShowSmartReportModal(true) }}
                >
                    <span className="psc-spinner"><i className="fa fa-refresh fa-spin fa-fw"></i></span>
                    SMART Report (.docx)
                </button>
            ) :
            (
                <button
                    className="btn btn-xs"
                    type="button"
                    onClick={() => setShowSmartReportInformationModal(true)}
                >
                    <i className="fa fa-info-circle"></i> SMART Report
                </button>
            )
        
        return (
            <tr key={stage.id || stage.timestamp} className={stage.cssClassName}>
                <td style={{whiteSpace: 'nowrap'}}>
                    {dateFormat(stage.created_at, 'dd-mm-yyyy')}
                </td>
                <td style={{whiteSpace: 'nowrap'}}>
                    {stage.code}
                </td>
                <td>
                    {stage.name}
                </td>
                <td style={{whiteSpace: 'nowrap'}}>
                    <button type="button" className="btn btn-xs btn-secondary"
                        onClick={() => viewReportStageHtml(stage)}>Quick look</button>
                    &nbsp;
                    <button type="button" className={'btn btn-xs btn-info has-spinner ' + (spinner === wordSpinner ? 'active' : '')}
                        onClick={() => viewReportStageDocx(stage)}>
                        <span className="psc-spinner"><i className="fa fa-refresh fa-spin fa-fw"></i></span>
                        Word (.docx)
                    </button>
                    &nbsp;

                    {smart}
                    &nbsp;
                    
                    { canDeleteStage &&
                        <Confirm
                            onConfirm={() => removeStage(stage)}
                            bodyContent="Are you sure you want to delete this?"
                            confirmText="Confirm Delete"
                            title="Delete"
                        >
                            <button type="button" className="btn btn-xs btn-warning">Delete</button>
                        </Confirm>
                    }
                </td>
            </tr>
        )
    }
    
    const viewReportStageHtml = (stage) => {
        setShowReportStageHtml(true)
        setReportStageHtml('<h2>Loading...</h2>')
        if( htmlTimeout ) {
            clearTimeout(htmlTimeout)
        }
        fetch('/v0/report_stages/' + stage.id + '/html', { credentials: 'same-origin' })
            .then(function(response) {
                return response.json()
            })
            .then(function(json) {
                if(json.error) {
                    throw Error(json.error)
                }
                setReportStageHtml(json.result.content)
            })
            .catch(function(error) {
                let timeout = setTimeout(function() { viewReportStageHtml(stage); }, 1000);
                setHtmlTimeout(timeout)
            })
    }
    
    const viewReportStageDocx = (stage) => {
        const name = 'GNC Go Export - ' + project.project_code + ' - ' + reportTitle + ' - ' + stage.code + '.docx'
        viewDocx('/v0/report_stages/' + stage.id + '/docx', name, 'word_'+stage.id)
    }

    const viewReportStageSmart = () => {
        const stage_id = smartStage.id
        const stage_code = smartStage.code
        const document_id = smartDocument.id
        let url = '/v0/report_stages/' + stage_id + '/smart'
        if( document_id && document_id > 0 ) {
            url += '?document_id=' + document_id
        }
        const name = 'GNC Go SMART Report - ' + props.project.project_code + ' - ' + reportTitle + ' - ' + stage_code + '.docx'
        viewDocx(url, name, "smart_modal", onCloseSmartReportModal)
    }

    const viewDocx = (url, documentName, spinnerCode, successCallback) => {
        if( spinner !== '' ) {
            return
        }
        setSpinner(spinnerCode)
        if( docxTimeout ) {
            clearTimeout(docxTimeout)
        }
        fetch(url, { credentials: 'same-origin' })
            .then(function(response) {
                return response.json()
            })
            .then(function(json) {
                if(json.error) {
                    throw Error(json.error)
                }
                let content = atob(json.result.content)
                let bytes = new Uint8Array(content.length);
                for (let i = 0; i < bytes.length; i++) {
                    bytes[i] = content.charCodeAt(i);
                }

                let blob = new Blob([bytes], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' })
                let url = URL.createObjectURL(blob);

                var a = document.createElement('a');
                a.setAttribute('target', '_blank');
                a.setAttribute('href', url);
                a.setAttribute('download', documentName);
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                setSpinner('')
                if( successCallback ) {
                    successCallback()
                }
            })
            .catch(function(error) {
                let timeout = setTimeout(function() { viewDocx(url, documentName, spinnerCode, successCallback); }, 1000);
                setDocxTimeout(timeout)
            })
    }

    if( ! hasStages || hasStages === 0 ) {
        return null
    }
        
    return (
            <div>
                {renderForm()}

                <div className="hr-line-dashed"></div>
                
                <div className="form-group">
                    <label className="col-sm-2"></label>
                    <div className="col-sm-8">
                        <h3 className="stages--tracking-reports">Tracking Reports</h3>
                        <p>
                            View and compare previous Baselines with Tracking Reports.
                        </p>
                    </div>
                </div>

                <div className="form-group">
                    <label className="col-sm-2 control-label"></label>
                    <div className="col-sm-8">
                        <table className="table table-striped table-bordered table-hover" >
                            <thead>
                                <tr>
                                    <th style={{whiteSpace: 'nowrap'}}>Date</th>
                                    <th style={{whiteSpace: 'nowrap'}}>Baseline ID</th>
                                    <th>Description</th>
                                    <th style={{whiteSpace: 'nowrap'}}>Action</th>
                                </tr>
                            </thead>
                            <tfoot>
                                <tr>
                                    <th style={{whiteSpace: 'nowrap'}}>Date</th>
                                    <th style={{whiteSpace: 'nowrap'}}>Baseline ID</th>
                                    <th>Description</th>
                                    <th style={{whiteSpace: 'nowrap'}}>Action</th>
                                </tr>
                            </tfoot>
                            <tbody>
                                {reportStages.map(renderTableRow)}
                            </tbody>
                        </table>
                    </div>
                </div>
                
                <InfoModal
                    title="SMART Reports"
                    titleIcon="fa fa-info-circle"
                    bodyContent={
                        <div>
                            <p>SMART Reports output a full tracking report directly into your own MS Word document.</p>
                            
                            <p>To use a SMART Report add a SMART Report template to this report scheme <br/>(CADM Admin permissions needed).</p>
                        </div>
                    }
                    show={showSmartReportInformationModal}
                    onClose={() => setShowSmartReportInformationModal(false)}
                />
                
                <Modal show={showReportStageHtml} onHide={onCloseReportStageHtml} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title className="text-center full-width">
                            <i  style={{fontSize: '84px', color: '#e2e3e3'}} className="fa fa-files-o" />
                            <h4 style={{fontSize: '28px'}}>Tracking Report</h4>
                            <h4 style={{fontSize: '18px'}}>{reportTitle}</h4>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div dangerouslySetInnerHTML={{__html: reportStageHtml}}></div>
                    </Modal.Body>
                </Modal>
                
                <Modal show={showSmartReportModal} onHide={onCloseSmartReportModal} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>
                        <i className="fa fa-file-text modal-icon"></i> Create a SMART Report Document?
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="form-group stages-smart-modal--intro">
                            <p>Select which reserved Document your SMART Report will create.</p>

                            <p>Or skip this to create an unreferenced SMART Report.</p>
                        </div>
                            
                        <div className="form-group">
                            <SingleSelect
                                options={reservedDocuments}
                                value={smartDocument.id}
                                onChange={(value) => setSmartDocument(value) }
                            />
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="light" onClick={onCloseSmartReportModal}>
                            Close
                        </Button>
                        <button type="button" className={'btn btn-info has-spinner ' + (spinner === 'smart_modal' ? 'active' : '')}
                                onClick={() => viewReportStageSmart(0)}
                        >
                            <span className="psc-spinner"><i className="fa fa-refresh fa-spin fa-fw"></i></span>
                            Create SMART Report
                        </button>
                    </Modal.Footer>
                </Modal>

            </div>
        )
}

export default Stages
